import { ExplainModule, UserModuleTypeEnum, UserPlanEnum } from '../../core/user/user.model';

export interface ResponseModuleState {
  isExpired: boolean;
  isTrial: boolean;
  planLabel: string;
  nbAllowed: number | null;
  nbCreated: number | null;
  diffDays: number | null;
  expirationDate: string | null;
  plan: UserPlanEnum | null;
  accountType: UserModuleTypeEnum | null;
}

export function getResponseModuleDiffDays(responseModule: ExplainModule): number | null {
  if (!responseModule.expiration_date) return null;
  return Math.ceil((new Date(responseModule.expiration_date).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

function formatExpirationDate(date?: Date): string | null {
  if (!date) return null;
  return new Date(date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
}

const PLAN_LABELS: Partial<Record<UserPlanEnum, string>> = {
  [UserPlanEnum.PRO]: 'Pro',
  [UserPlanEnum.BUSINESS]: 'Business',
  [UserPlanEnum.ENTERPRISE]: 'Enterprise',
};

export function getPlanLabel(plan: UserPlanEnum | null | undefined): string {
  return (plan && PLAN_LABELS[plan]) ?? '';
}

export function computeResponseModuleState(modules: ExplainModule[]): ResponseModuleState | null {
  const responseModule = modules.find(m => m.name === 'response');
  if (!responseModule) return null;
  const diffDays = getResponseModuleDiffDays(responseModule);
  return {
    isExpired: diffDays !== null && diffDays <= 0,
    isTrial: responseModule.type !== UserModuleTypeEnum.PAID,
    planLabel: getPlanLabel(responseModule.permissions?.plan),
    nbAllowed: responseModule.permissions?.nb_allowed_projects ?? null,
    nbCreated: responseModule.permissions?.nb_created_projects ?? null,
    diffDays,
    expirationDate: formatExpirationDate(responseModule.expiration_date),
    plan: responseModule.permissions?.plan ?? null,
    accountType: responseModule.type ?? null,
  };
}
